document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.mv-swiper');

  if (swiperEl && swiperEl.querySelectorAll('.swiper-slide').length >= 3) {
    const mvSwiper = new Swiper('.mv-swiper', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      loopedSlides: 5, // ← こちらを使用（Swiperの推奨）
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  } else {
    // スライドが少なすぎる場合はシンプル構成で表示
    new Swiper('.mv-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }
});
